import createRoute      from '@widesk-ui/tools/createRoute';
import PeriodGroupModel from '@models/shop/PeriodGroupModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/period_groups', 'shop', 'PeriodGroupDashboard', PeriodGroupModel.localize());
